import { render, staticRenderFns } from "./DashboardPrintQueueUser.vue?vue&type=template&id=4db64d86&"
import script from "./DashboardPrintQueueUser.vue?vue&type=script&lang=js&"
export * from "./DashboardPrintQueueUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports